export const USER_ROLE_OPTIONS = {
    anonymous: {
        value: '1',
        viewValue: 'Anonymous',
        key: 'anonymous'
    },
    user: {
        value: '2',
        viewValue: 'User',
        key: 'user'
    },
    orgAdmin: {
        value: '3',
        viewValue: 'Organisation Admin',
        key: 'orgAdmin'
    },
    customerSupport: {
        value: '4',
        viewValue: 'Customer Support',
        key: 'customerSupport'
    },
    superAdmin: {
        value: '5',
        viewValue: 'Super Admin',
        key: 'superAdmin'
    }
};